import dayjs from "dayjs";
/**
 * Форматирование денег/дат для вкладки «Взаиморасчёты» (UC1120). Две цифры после запятой,
 * разряды тысяч — неразрывный узкий пробел (контракт §10.2, единообразно со сводкой шапки).
 */
const moneyFormatter = new Intl.NumberFormat("ru-RU", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});
export const formatMoney = (value) => moneyFormatter.format(value);
export const formatDate = (value) => (value ? dayjs(value).format("DD.MM.YYYY") : "—");
export const formatDateTime = (value) => (value ? dayjs(value).format("DD.MM.YYYY HH:mm") : "—");
